import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import React from 'react';
import styled from 'styled-components';
import { SpaceProps } from 'styled-system';
import Box from 'ui/Box';
import Body from 'ui/Typography/Body';
import Title from 'ui/Typography/Title';
import WarningIcon from './warning.svg?react';

type Props = SpaceProps & {
  title: string;
  content: string;
};

const Wrapper = styled(Box)`
  max-width: 100rem;
  margin: ${({ theme }) => theme.space.s} auto ${({ theme }) => theme.space.xl};
`;

const Flex = styled.div`
  display: flex;
  align-items: center;

  @media print {
    visibility: hidden;
    display: none;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Warning = styled(WarningIcon)`
  width: ${({ theme }) => theme.space.xxl};
  height: ${({ theme }) => theme.space.xxl};
  margin-right: ${({ theme }) => theme.space.l};
  margin-left: ${({ theme }) => theme.space.s};
`;

const WarningBanner = ({ title, content, ...props }: Props) => {
  return (
    <Wrapper p="s" mb="xl" backgroundColor="#FEEDD3" {...props}>
      <Flex>
        <Warning />
        <Content>
          <Title type={ThemeFontStyleTypeEnum.headingMedium}>{title}</Title>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium}>{content}</Body>
        </Content>
      </Flex>
    </Wrapper>
  );
};

export default WarningBanner;
